import React, { useState, useEffect } from 'react'
import './App.css';
import { BrowserRouter, Switch, Route } from 'react-router-dom'


import BirditHome from './components/BirditHome/Home';
import Login from './components/Login/Login'
import Admin from './components/Admin/Admin'
import Responses from './components/Responses/Responses';
import Header from './components/Header/Header';
import UsersPage from './components/Users/UsersPage';
import Table from './components/Table/Table'
import Home from './Pages/Home/Home';


function App() {
 
  //Retrieve user details from local storage
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')))
  console.log(user)

  useEffect(()=> {
      
      setUser(JSON.parse(localStorage.getItem('profile')))
  }, []) 

 
  return (
    <BrowserRouter>
      <Header />
      <Switch>
        <Route path="/" exact component={Home} />
        <Route path="/birdit" exact component={BirditHome} />
        <Route path="/login" exact component={Login} />
        <Route path="/admin" exact component={Admin} />
        <Route path="/users" exact component={UsersPage} />
        <Route path="/activities" exact component={Responses} />
        <Route path="/log" exact component={Table} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;


// {
//   birds.map((species) => {
//     return (
//       <div key={species.name}>
//       <h1>{species.name}</h1>
//     </div>
//     )
    
//   })
// }